import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { api } from "@/lib/api";
import { todayZurich } from "@/lib/format";
import { Field, Sel } from "@/components/Field";
import { FormDialog, useSubmit, clean } from "./FormDialog";

export const MINUTE_KINDS = { assemblea: "Assemblea", comitato: "Comitato", altro: "Altro" };
const EMPTY = { title: "", date: "", kind: "assemblea", location: "", attendees: "", body: "" };

export const MinuteDialog = ({ open, onOpenChange, minute, onSaved }) => {
  const [f, setF] = useState(EMPTY);
  const { saving, run } = useSubmit();
  const set = (k) => (v) => setF((s) => ({ ...s, [k]: v?.target ? v.target.value : v }));
  useEffect(() => {
    if (open) setF(minute ? Object.fromEntries(Object.keys(EMPTY).map((k) => [k, minute[k] ?? ""])) : { ...EMPTY, date: todayZurich() });
  }, [open, minute]);

  const submit = () =>
    run(async () => {
      const { data } = minute ? await api.patch(`/minutes/${minute.id}`, clean(f)) : await api.post("/minutes", clean(f));
      onOpenChange(false);
      onSaved?.(data);
    }, minute ? "Verbale aggiornato" : "Verbale creato");

  return (
    <FormDialog open={open} onOpenChange={onOpenChange} title={minute ? "Modifica verbale" : "Nuovo verbale"} onSubmit={submit} saving={saving} testId="minute-dialog" wide>
      <Field label="Titolo *"><Input data-testid="minute-title-input" required value={f.title} onChange={set("title")} className="h-11" placeholder="Es. Assemblea generale ordinaria" /></Field>
      <div className="grid grid-cols-2 gap-3">
        <Field label="Data *"><Input data-testid="minute-date-input" type="date" required value={f.date} onChange={set("date")} className="h-11" /></Field>
        <Field label="Tipo"><Sel testId="minute-kind-select" value={f.kind} onChange={set("kind")} options={Object.entries(MINUTE_KINDS).map(([value, label]) => ({ value, label }))} /></Field>
      </div>
      <Field label="Luogo"><Input data-testid="minute-location-input" value={f.location} onChange={set("location")} className="h-11" /></Field>
      <Field label="Presenti"><Textarea data-testid="minute-attendees-input" value={f.attendees} onChange={set("attendees")} rows={2} /></Field>
      <Field label="Testo del verbale" hint="Potrai allegare PDF o immagini dopo il salvataggio"><Textarea data-testid="minute-body-input" value={f.body} onChange={set("body")} rows={10} /></Field>
    </FormDialog>
  );
};
